import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;
`;

const Video = ({ accountId, videoId, options, playerId, style }) => (
  <Wrapper options={options} style={style}>
    <iframe
      src={`//players.brightcove.net/${accountId}/${playerId}_default/index.html?videoId=${videoId}`}
      allowFullScreen
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      style={{
        position: 'absolute',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        border: '0',
      }}
      title="test"
    />
  </Wrapper>
);

Video.defaultProps = {
  style: {},
  options: {},
};

Video.propTypes = {
  accountId: PropTypes.number.isRequired,
  playerId: PropTypes.string.isRequired,
  videoId: PropTypes.number.isRequired,
  options: PropTypes.shape(),
  style: PropTypes.shape(),
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/BrightcoveVideo.js